import {
  RequestLinktreeEntriesList,
  RequestLinktreeEntryById,
} from "../dtos/linktree/entry";
import Server from "./index";

export default class LinktreeServer extends Server {
  constructor() {
    super("/linktree.php");
  }

  public get(
    params: RequestLinktreeEntriesList | RequestLinktreeEntryById
  ): Promise<any> {
    return super.get(params);
  }
}
